<template>
  <div class="home">
    <!-- 根据屏幕尺寸动态显示不同组件 -->
    <HomeDesktop v-if="responsiveState.isDesktop" />
    <HomeMobile v-else />

    <!-- 调试信息 -->

      </div>
</template>

<script>
import HomeDesktop from './HomeDesktop.vue'
import HomeMobile from './HomeMobile.vue'

export default {
  name: 'Home',
  components: {
    HomeDesktop,
    HomeMobile
  },
  data() {
    return {
      showDebug: false // 设置为true可以显示调试信息
    }
  },
  watch: {
    // 监听响应式状态变化
    'responsiveState.screenSize': {
      handler(newSize, oldSize) {
        console.log('断点变化:', oldSize, '->', newSize)
      }
    },
    'responsiveState.isDesktop': {
      handler(newValue, oldValue) {
        console.log('设备类型变化:', oldValue ? 'Desktop' : 'Mobile', '->', newValue ? 'Desktop' : 'Mobile')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  // 基础样式
}

.debug-info {
  position: fixed;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-size: 12px;
  z-index: 9999;

  p {
    margin: 5px 0;
  }
}
</style>
